import { useCallback, useMemo, useState } from "react";
import { WindowStorage } from "../services/storage";
import { Guid } from "guid-typescript";
import { StorageType } from "../services/storage.default";

export function useStorage(type?: StorageType): WindowStorage {
  const [trigger, setTrigger] = useState<any>(null);
  const fn = useCallback(() => {
    setTrigger(Guid.create().toString());
  }, []);
  const storage = useMemo(() => new WindowStorage(fn, type), [trigger]);

  return storage;
}
